import showLogs from './showLog';
import logList from './logList';

export default {
  list: logList,
  show: showLogs,
};
